import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer style={{ background: '#2D1A00', color: '#E8D5A3', padding: '40px 0 20px' }}>
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '30px', marginBottom: '30px' }}>
        <div>
          <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 12, color: '#D4A843' }}>Chakna Point</h3>
          <p style={{ fontSize: 13, color: '#B89B5E', lineHeight: 1.6 }}>Premium chakna & snacks delivered fast. Your perfect party companion.</p>
        </div>
        <div>
          <h4 style={{ fontSize: 14, fontWeight: 600, marginBottom: 12, color: '#D4A843' }}>Legal</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: 13 }}>
            <Link to="/privacy-policy" style={{ color: '#B89B5E' }}>Privacy Policy</Link>
            <Link to="/terms-and-conditions" style={{ color: '#B89B5E' }}>Terms & Conditions</Link>
            <Link to="/refund-policy" style={{ color: '#B89B5E' }}>Refund Policy</Link>
            <Link to="/delete-account" style={{ color: '#B89B5E' }}>Delete Account</Link>
          </div>
        </div>
        <div>
          <h4 style={{ fontSize: 14, fontWeight: 600, marginBottom: 12, color: '#D4A843' }}>Company</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: 13 }}>
            <Link to="/about-us" style={{ color: '#B89B5E' }}>About Us</Link>
            <Link to="/contact-us" style={{ color: '#B89B5E' }}>Contact Us</Link>
          </div>
        </div>
        <div>
          <h4 style={{ fontSize: 14, fontWeight: 600, marginBottom: 12, color: '#D4A843' }}>Contact</h4>
          <p style={{ fontSize: 13, color: '#B89B5E' }}>support@chaknapoint.com</p>
          <p style={{ fontSize: 13, color: '#B89B5E' }}>+91 98765 43210</p>
        </div>
      </div>
      <div style={{ borderTop: '1px solid #5C3D0E', paddingTop: 16, textAlign: 'center', fontSize: 12, color: '#8B6914' }}>
        © {new Date().getFullYear()} Chakna Point. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
